import { render, staticRenderFns } from "./foldersPage.vue?vue&type=template&id=96bd6a7a&scoped=true"
import script from "./foldersPage.vue?vue&type=script&lang=js"
export * from "./foldersPage.vue?vue&type=script&lang=js"
import style0 from "./foldersPage.vue?vue&type=style&index=0&id=96bd6a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bd6a7a",
  null
  
)

export default component.exports